import React, { PropsWithChildren, ReactElement } from 'react';
import classNames from 'classnames';

type FormGroupSpacing = 'loose' | 'compressed';

export type FormGroupProps = PropsWithChildren<{
  className?: string;
  errors?: string[];
  horizontal?: boolean;
  inline?: boolean;
  spacing?: FormGroupSpacing;
  testId?: string;
}>;

export function FormGroup({
  children,
  className,
  errors = [],
  horizontal = false,
  inline = false,
  spacing,
  testId,
}: FormGroupProps): ReactElement {
  const classes = classNames('form-group', className, {
    'form-group--error': errors.length,
    'form-group--horizontal': horizontal,
    'form-group--inline': inline,
    [`form-group--${spacing}`]: !!spacing,
  });

  return (
    <div className={classes} data-testid={testId}>
      {children}
      {errors.map((error) => (
        <div key={error} className="help-block" role="alert">
          <span>{error}</span>
        </div>
      ))}
    </div>
  );
}
